import React from 'react';
import loadingIcon from 'assets/images/loading.gif';
import './LoadingPage.scss';

export default function LoadingPage() {
  return (
    <div className="loading-page">
      <img className="loader-icon" src={loadingIcon} alt="loading" />
    </div>
  );
}
